import { observer } from "mobx-react-lite";
import { useState } from "react";
import ReactPlayer from "react-player";
import { TCText } from "../../../components/TCText/TCText";
import { MatchVideo } from "../../../apis/types";

type props = {
  videoData: MatchVideo[];
};

export const VideosSection = observer(({ videoData }: props) => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleVideoClick = (videoUrl: string) => {
    setSelectedVideo(videoUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          gap: 12,
          marginTop: 18,
          paddingBottom: 4,
          position: "relative",
        }}
      >
        {videoData.map((video, index) => (
          <div key={index}>
            <img
              src={video.thumbnailUrl ?? ""}
              alt=""
              style={{
                width: 140,
                height: 80,
                borderRadius: 10,
                objectFit: "cover",
              }}
              onClick={() => handleVideoClick(video.url ?? "")}
            />
            <TCText
              value={video.label ?? ""}
              style={{ fontSize: 10, marginTop: 4 }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                width: 140,
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.4))",
                }}
              >
                <circle cx="20" cy="20" r="20" fill="rgba(0,0,0,0.5)" />
                <polygon points="16,13 28,20 16,27" fill="#fff" />
              </svg>
            </div>
          </div>
        ))}
      </div>
      {/* Full-screen Video Modal */}
      {isModalOpen && selectedVideo && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: -40,
                right: 0,
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
                zIndex: 1001,
                padding: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>

            {/* Video Player */}
            <ReactPlayer
              src={selectedVideo}
              width="100%"
              height="100%"
              controls={true}
              playing={true}
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
});
